import { useQuery } from "react-query";

import { RQ_KEY } from "../../constants/query";
import { getEvent } from "../../services/events";
import { TEventId } from "../schemas/event";

export default function useQueryEvent(eventId: string | undefined) {
  return useQuery<TEventId, Error>([RQ_KEY.EVENT], () => getEvent(eventId as string));
}
